module.exports = __webpack_public_path__ + "img/closed@3x.e3f80230.png";